// extracted by mini-css-extract-plugin
module.exports = {"NewPatternConstraintsBlock":"NewPatternConstraint_NewPatternConstraintsBlock__2gn2e"};